import { Box, Icon, Text } from '@bonanza-social/moonlight';
import { memo, useMemo } from 'react';
import { MysteryBoxInfoProps } from './MysteryBoxInfo.types';
import ShopMisteryBoxInfoItemList from '../../components/ShopMisteryBoxInfoItemList/ShopMisteryBoxInfoItemList';
import { cloneDeep } from 'lodash-es';
import ShopMysteryBoxInfoTopPrizes from '../../components/ShopMysteryBoxInfoTopPrizes/ShopMysteryBoxInfoTopPrizes';
import { ScrollView } from 'react-native-gesture-handler';

function MysteryBoxInfo({ description, itemDrops }: MysteryBoxInfoProps) {
  const { topPrizes, otherPrizes } = useMemo(() => {
    const topPrizes = [];
    const otherPrizes = [];

    const sortedPrizes = cloneDeep(itemDrops);
    sortedPrizes.sort((a, b) => (a.weight > b.weight ? 1 : -1));

    for (const prize of sortedPrizes) {
      if (prize.isTopPrize) {
        topPrizes.push(prize);
      } else {
        otherPrizes.push(prize);
      }
    }

    return { topPrizes, otherPrizes };
  }, [itemDrops]);

  return (
    <Box gap="space-400">
      {description ? (
        <Text variant="body-m-semi" color="darkSurfacePrimary">
          {description}
        </Text>
      ) : null}
      <ScrollView style={{ maxHeight: 350 }} nestedScrollEnabled>
        <ShopMysteryBoxInfoTopPrizes items={topPrizes} />
        <ShopMisteryBoxInfoItemList items={otherPrizes} />
      </ScrollView>
      <Box
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        gap="space-200"
        padding="space-200"
        borderRadius="radius-300"
        backgroundColor="primaryBackgroundHover"
      >
        <Icon
          name="warning"
          width="space-500"
          height="space-500"
          gradient="accentBackground"
        />
        <Box flexWrap="wrap" flex={1}>
          <Text
            width="100%"
            variant="caption"
            color="darkSurfacePrimary"
            locNS="shop"
            locKey="shopMisteryBoxDisclaimer"
          />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(MysteryBoxInfo);
